import Joi from "joi";
import {
  allPricesAreEmpty,
} from "./product";

import {
  MONTHLY_PRICE_LABEL,
  ANNUAL_PRICE_LABEL,
  nameSchema,
} from './constants';

import {trimBlankPrices} from "./methods";

/**
 * Used to validate the user-created support addon.
 * Validation logic is a little more verbose here, as it directly depends on the softwareProduct.
 */
export function validateSupportAddon(state, {softwareProduct, supportAddon}) {
  const {prices: softwarePrices} = softwareProduct;
  const {supportedCurrencies} = state;

  const validCurrencies = Object.keys(supportedCurrencies);

  let joiSchema = {
    currency: Joi.string().valid(...validCurrencies),
  };

  let currencySchemas = {};

  validCurrencies.forEach((currencyCode) => {
    currencySchemas[currencyCode] = {
      monthlyRaw: Joi.any(),
      annualRaw: Joi.any(),
    };

    if (softwarePrices[currencyCode].monthlyRaw > 0) {
      currencySchemas[currencyCode].monthlyRaw = Joi.number()
        .required()
        .min(100)
        .messages({
          'number.min': 'This price is below the minimum amount.',
        })
        .label(MONTHLY_PRICE_LABEL);
    }

    if (softwarePrices[currencyCode].annualRaw > 0) {
      currencySchemas[currencyCode].annualRaw = Joi.number()
        .required()
        .min(100)
        .messages({
          'number.min': 'This price is below the minimum amount.',
        })
        .label(ANNUAL_PRICE_LABEL);
    }
  });

  let perPriceSchema = Joi.object(joiSchema)
    .unknown(true)
    .messages({
      'object.missing': `Please enter a monthly or annual price.`,
      'number.integer': `{#label} must be a valid number.`,
    });

  /*if (allPricesAreEmpty(supportedCurrencies, prices)) {
    perPriceSchema = perPriceSchema.or('monthlyRaw', 'annualRaw');
  }*/

  const supportAddonSchema = Joi.object({
    name: nameSchema,
    prices: currencySchemas,
  }).unknown(true);

  let enabledCurrencies = Object.entries(supportedCurrencies)
    .map(([currencyCode, {enabled}]) => {
      return enabled ? currencyCode : false;
    });

  /**
   * Tweaking the product to only validate name and price.
   * Prices are tweaked on the fly, see: () method for more info.
   */
  const trimmedAddon = {
    name: supportAddon.name,
    prices: supportAddon.prices,//trimBlankPrices(supportAddon.prices, enabledCurrencies),
    supportedCurrencies: validCurrencies,
  };

  const {error: errors} = supportAddonSchema.validate(
    trimmedAddon,
    { abortEarly: false }
  );
  return errors;
}
